import {Container} from "pixi.js-legacy";

/**
 * This class is just a container
 */
export class FighterView extends Container {}
